import React from "react";
import { useTranslation } from "react-i18next";

const STATUS_STYLES = {
  Draft: "bg-slate-100 text-slate-600 border-slate-200",
  Published: "bg-blue-50 text-blue-700 border-blue-200",
  "Designer Selected": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "In Progress": "bg-amber-50 text-amber-700 border-amber-200",
  Submitted: "bg-violet-50 text-violet-700 border-violet-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`status-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
        STATUS_STYLES[status] || STATUS_STYLES.Draft
      }`}
    >
      {t(`status.${status}`)}
    </span>
  );
};

const COMPLEXITY_STYLES = {
  Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  High: "bg-rose-50 text-rose-700 border-rose-200",
};

export const ComplexityBadge = ({ complexity }) => {
  const { t } = useTranslation();
  if (!complexity) return null;
  return (
    <span
      data-testid={`complexity-badge-${complexity.toLowerCase()}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
        COMPLEXITY_STYLES[complexity] || COMPLEXITY_STYLES.Medium
      }`}
    >
      {t("complexity.label")}: {t(`complexity.${complexity}`)}
    </span>
  );
};
